<template>
    <div class="d-flex h-100 wos__wrapper mt-8 mt-lg-0">
        <BugReportHelper/>
        <div class="release" v-if="$releaseText">
            <p class="release-text noselect">{{$releaseText}}</p>
        </div>
        <Aside/>
        <main class="wos__main-content-wrapper p-5 d-flex flex-column" id="wos3_main_container">
            <div class="container-fluid d-none d-lg-block">
                <div class="row justify-content-lg-between align-items-end mb-5">
                    <div class="col-6 py-3">
                    </div>
                    <div class="col-6 wos__submenu">
                        <TopBar/>
                    </div>
                </div>
            </div>
            <div class="container-fluid">
                <div class="row">
                    <div class="wos__content container-fluid">
                        <router-view/>
                        <ExplorerHistory/>
                        <div class="container-fluid mt-3">
                            <div class="row">
                                <div class="col text-muted">
                                    <div class="row">
                                        <div class="col">
                                            SERVER: v{{serverVersion}}
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            UI: v{{frontendVersion}} - <span class="font-weight-light"> {{buildTime | formatDate(true, true)}} UTC</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col text-right">
                                    2016 - {{(new Date().getFullYear())}} &copy; {{$t('company')}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import TopBar from "../components/application/TopBar";
import Aside from "../components/application/Aside";
import BugReportHelper from "@/components/application/BugReportHelper";
import ExplorerHistory from "@/components/application/ExplorerHistory";

export default {
    name: "ApplicationLayout",
    components: {ExplorerHistory, BugReportHelper, Aside, TopBar},
    data() {
        return {
            buildTime: parseInt(document.documentElement.dataset.build)
        }
    },

    computed: {
        frontendVersion() {
            return this.$app.version.frontend;
        },

        serverVersion() {
            return this.$parent.version;
        }
    }
}
</script>

<style scoped>

</style>
